import { LucideProps } from 'lucide-react'

const PaperAirplane = (props: LucideProps) => (
  <svg
    width="28"
    height="26"
    viewBox="0 0 28 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      id="Vector"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.2344 0.310547L22.2336 21.6707L12.5221 18.3384L21.1884 6.96984L10.0042 17.5241L0.923038 14.4666L27.2344 0.310547ZM12.2152 25.8926L12.2152 20.0148L15.4121 21.0356L12.2152 25.8926Z"
      fill={props.fill || '#DB4245'}
    />
  </svg>
)

export default PaperAirplane
